import { render, staticRenderFns } from "./PdpSparePartNumbersTab.vue?vue&type=template&id=2ce9e95e&scoped=true&"
import script from "./PdpSparePartNumbersTab.vue?vue&type=script&lang=js&"
export * from "./PdpSparePartNumbersTab.vue?vue&type=script&lang=js&"
import style0 from "./PdpSparePartNumbersTab.vue?vue&type=style&index=0&id=2ce9e95e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce9e95e",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpdp-spare-part-numbers-tab%2FPdpSparePartNumbersTab.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports